import { render } from "./Result.vue?vue&type=template&id=41ce88a6"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"
script.render = render

export default script